import '../components/VoiceActorProfileForm.css'; // Reuse the same CSS


export const SimpleValuesDisplay = ({ values, errors = {}, touched = {}, isFormChanged }) => {
  // Helper function to render different value types
  const renderValue = (value) => {
    // Handle null or undefined
    if (value === null || value === undefined) {
      return 'null';
    }

    // Handle boolean values
    if (typeof value === 'boolean') {
      return value.toString();
    }

    // Handle File objects
    if (value instanceof File) {
      return (
        <div className="values-display-file-info">
          <div><strong>File Name:</strong> {value.name}</div>
          <div><strong>Type:</strong> {value.type}</div>
          <div><strong>Size:</strong> {formatFileSize(value.size)}</div>
          <div><strong>Last Modified:</strong> {new Date(value.lastModified).toLocaleString()}</div>
        </div>
      );
    }

    // Handle arrays
    if (Array.isArray(value)) {
      return JSON.stringify(value);
    }

    // Handle objects (excluding Files which were handled above)
    if (typeof value === 'object') {
      return JSON.stringify(value);
    }

    // Default case: return as string
    return String(value);
  };

  // Helper function to format file size
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  // Helper function to determine if a field has an error
  const hasError = (fieldName) => {
    return touched[fieldName] && errors[fieldName];
  };

  // Helper function to get field status
  const getFieldStatus = (fieldName) => {
    if (hasError(fieldName)) return 'error';
    if (touched[fieldName]) return 'valid';
    return 'untouched';
  };

  return (
    <div className="values-display">
      <h3>Form Values - isFormChanged {isFormChanged.toString()}</h3>
      <dl className="values-list">
        {Object.entries(values).map(([key, value]) => (
          <div key={key} className={`value-item ${hasError(key) ? 'error-field' : ''}`}>
            <dt>{key}:</dt>
            <dd>
              {renderValue(value)}
              {hasError(key) && (
                <div className="field-error-message">
                  {errors[key]}
                </div>
              )}
            </dd>
          </div>
        ))}
      </dl>

      {/* Add a validation summary section */}
      {Object.keys(errors).length > 0 && (
        <div className="validation-summary">
          <h4>Validation Errors:</h4>
          <ul>
            {Object.entries(errors).map(([field, error]) => (
              <li key={field} className={touched[field] ? 'touched-error' : 'untouched-error'}>
                <strong>{field}:</strong> {error}: {values[field]}
                {console.log('invalid: ', field, 'error', error, 'value', values[field])}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
